<section id="conceptArt">
	<h5 i18n="conceptArt@@media.conceptArt.headline">Concept Art</h5>
	<div class="featured-gallery">
		<div *ngFor="let item of items; index as i" class="item" [class.featured]="i==0">
			<div  (click)="openLightBox(i)"
				 [style.backgroundImage]="'url(' + item.data.thumb + ')'" class="thumbImage" angulartics2On="click" angularticsAction="openConceptArtButton" angularticsCategory="media"></div>

			<!-- [lightbox]="i"
				 [gallery]="'conceptLightbox'" -->
		</div>
	</div>
</section>